import type { FeatureModuleKey } from '@/utils/featureModules';

/**
 * 路由名 → 功能模块。未列出的路由不做模块开关拦截（如 Dashboard 对话首页、个人中心）。
 */
const ROUTE_FEATURE_MODULE: Record<string, FeatureModuleKey> = {
  KnowledgeSpace: 'knowledge',

  AiTools: 'aiTools',
  AiRequirementLedger: 'aiTools',
  AiRequirementDetail: 'aiTools',
  AiSmartReview: 'aiTools',
  AiCalculator: 'aiTools',
  AiCalculatorDetail: 'aiTools',
  Ai3DViewer: 'aiTools',
  Ai3DViewerOfflinePreview: 'aiTools',
  Ai3DViewerSharePreview: 'aiTools',
  Resources: 'aiTools',
  ResourceCreate: 'aiTools',
  ResourceDetail: 'aiTools',

  ProjectCreate: 'projectManagement',
  ProjectDashboard: 'projectManagement',
  ProjectDocumentViewer: 'projectManagement',
  ProjectRequirements: 'projectManagement',
  ProjectWbsSnapshot: 'projectManagement',
  Requirements: 'projectManagement',
  Designs: 'projectManagement',

  SmartDocumentWorkbenchHome: 'smartDocument',
  SmartDocumentWorkbench: 'smartDocument',
};

export function featureModuleForRoute(routeName: string | symbol | null | undefined): FeatureModuleKey | null {
  if (!routeName || typeof routeName !== 'string') return null;
  return ROUTE_FEATURE_MODULE[routeName] ?? null;
}
